import { Component, Input, ViewEncapsulation, SimpleChanges, OnChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { first, forkJoin } from 'rxjs';
import { PermissionDashboardPage } from '@app/shared/services/api/permission.service';
import { environment } from '@env/environment';
import { Tenant } from '@app/shared/enums';
import { StringUtility } from '@app/shared/string-utility';

@Component({
  selector: 'app-dashboard-panel',
  templateUrl: './dashboard-panel.component.html',
  styleUrls: ['./dashboard-panel.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DashboardPanelComponent implements OnChanges {
  @Input() title?: string;
  @Input() src!: string;
  @Input() hoverSrc!: string;
  @Input() badgeCount?: number;
  @Input() hasNotification?: boolean;
  @Input() isPremium?: boolean;
  @Input() isTeaser?: boolean;
  @Input() isWarmeDaten?: boolean;
  @Input() isNewTeaserText?: boolean;
  @Input() code?: string;
  @Input() item?: PermissionDashboardPage;

  teaserSvg?: string | SafeHtml;
  hoverSvg?: string | SafeHtml;
  svg?: string | SafeHtml;
  activeSvg?: ActiveSvgType;
  showPremium?: boolean;
  showLearnMore?: boolean;
  showCreateTeaser?: boolean;
  public isExterneApp: boolean = false;
  public externeIcon: string = '';
  public hoverExterneIcon: string = '';
  public oneEPColors: boolean = false;
  
  constructor(public sanitizer: DomSanitizer, public httpClient: HttpClient) {
    this.oneEPColors = StringUtility.areStringsIdentical(environment.tenant, Tenant.LECHWERKE);
  }

  ngOnChanges(changes: SimpleChanges) {
    const hoverSrcChange = changes['hoverSrc'];
    const badgeCountChange = changes['badgeCount'];
    const notificationChange = changes['hasNotification'];

    if (this.item?.featureType === 'E') {
      this.isExterneApp = true;
      this.externeIcon = this.getExterneIcon(0);
      this.hoverExterneIcon = this.getExterneIcon(1);
    } else {
      const svg = this.httpClient.get(this.src, { responseType: 'text' });
      const hoverSvg = this.httpClient.get(this.hoverSrc, {
        responseType: 'text',
      });

      forkJoin([svg, hoverSvg])
        .pipe(first())
        .subscribe((data: any[]) => {
          this.svg = this.sanitizer.bypassSecurityTrustHtml(data[0]);
          this.hoverSvg = this.sanitizer.bypassSecurityTrustHtml(data[1]);
          this.teaserSvg = this.sanitizer.bypassSecurityTrustHtml(data[0].replace('class="svg"', 'class="svg-teaser"'));
          this.showDefaultImage(this.svg);
        });
    }

    if (hoverSrcChange && !hoverSrcChange.firstChange && hoverSrcChange.previousValue !== hoverSrcChange.currentValue) {
      this.showLearnMore = false;
      this.httpClient.get(this.hoverSrc, { responseType: 'text' }).subscribe((data: string) => {
        this.hoverSvg = this.sanitizer.bypassSecurityTrustHtml(data);
        if (badgeCountChange) {
          return;
        }
        if (notificationChange) {
          return;
        }
        this.showHoverImage(this.svg);
      });
    }
  }

  showDefaultImage(svg?: ActiveSvgType) {
    this.activeSvg = this.isPremium && this.isTeaser && !this.isWarmeDaten ? this.teaserSvg : svg;
    this.showPremium = this.isPremium && this.isTeaser && !this.isWarmeDaten;
    this.showLearnMore = false;
    this.externeIcon = this.isExterneApp ? this.getExterneIcon(0) : '';
  }

  showHoverImage(svg?: ActiveSvgType) {
    this.activeSvg = svg;
    this.showPremium = this.isPremium && !this.isWarmeDaten;
    this.showLearnMore = (this.isPremium || this.isExterneApp) && this.isTeaser && !this.isWarmeDaten;
    this.showCreateTeaser = this.isNewTeaserText;
    const hoverImg = this.getExterneIcon(1);
    this.externeIcon = hoverImg.length > 0 ? hoverImg : this.externeIcon;
  }

  private getExterneIcon(index: number): string {
    return this.src?.includes(';') ? this.src.split(';')[index] || '' : this.src || '';
  }
}

type ActiveSvgType = string | SafeHtml | MouseEvent;
